import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Fade } from 'react-awesome-reveal';

import { ThemeContext } from '../../contexts/ThemeContext';

import expImgWhite from '../../assets/svg/experience/expImgWhite.svg'

import './Experience.css'

function ExperienceCard({id, company, jobtitle, startYear, endYear, summary}) {

    const { theme } = useContext(ThemeContext);

    const useStyles = makeStyles((t) => ({
        experienceCard : {
            backgroundColor:theme.primary30,
            "&:hover": {
                backgroundColor:theme.primary50,
            },
        },
    }));

    const classes = useStyles();


    return (
        <Fade direction="up" triggerOnce>
            <div key={id} className={`experience-card ${classes.experienceCard}`}>
                <div className="expcard-img" style={{backgroundColor: theme.primary}}>
                    <img src={expImgWhite} alt="" />
                </div>
                <div className="experience-details">
                    <h6 style={{color: theme.primary}}>{startYear}-{endYear}</h6>
                    <h4 style={{color: theme.tertiary}}>{jobtitle}</h4>
                    <h5 style={{color: theme.tertiary80}}>{company}</h5>
                    {summary && <p style={{color: theme.tertiary80, marginTop: '0.45rem', lineHeight: 1.6}}>{summary}</p>}
                </div>
            </div>
        </Fade>   
    )
}

export default ExperienceCard
